import DashboardShareModal from './DashboardShareModal';

export default DashboardShareModal;
